export default __webpack_public_path__ + "static/media/upheavtt.e3d365ba.ttf";